import { render, staticRenderFns } from "./athenaProcutItem.vue?vue&type=template&id=205f4695&scoped=true&"
import script from "./athenaProcutItem.vue?vue&type=script&lang=js&"
export * from "./athenaProcutItem.vue?vue&type=script&lang=js&"
import style0 from "./athenaProcutItem.vue?vue&type=style&index=0&id=205f4695&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f4695",
  null
  
)

export default component.exports